<ftr-modal
  modalTitle="Delete Case Information"
  actionText="Delete"
  [type]="modalType.Warning"
  [actionButtonColor]="buttonColor.Danger"
  (action)="onDelete.emit()"
  [closeOnAction]="true"
>
  <p>This case information will be deleted. This action cannot be undone.</p>
</ftr-modal>
